import type { EntityInteraction } from "@/lib/api/shareable-entities";
import type { Comment } from "./entity-comments";

export interface Reaction {
  id: string;
  emoji: string;
  userId: string;
  userName: string;
}

export function getInteractionCardIndex(interaction: EntityInteraction): number {
  const index = interaction.metadata?.index;
  if (typeof index === "number" && Number.isInteger(index) && index >= 0) {
    return index;
  }
  return 0;
}

export function filterInteractionsByCardIndex(
  interactions: EntityInteraction[] | undefined,
  cardIndex: number,
): EntityInteraction[] {
  return (
    interactions?.filter(
      (interaction) => getInteractionCardIndex(interaction) === cardIndex,
    ) ?? []
  );
}

export function transformInteractionsToComments(
  interactions: EntityInteraction[] | undefined,
  currentUserId: string | undefined
): Comment[] {
  return (
    interactions
      ?.filter((i) => i.interactionType === "comment")
      .map((i) => ({
        id: i.id,
        content: i.content,
        timestamp: i.created_at,
        isOwn: i.user.id === currentUserId,
      })) ?? []
  );
}

export function transformInteractionsToReactions(
  interactions: EntityInteraction[] | undefined
): Reaction[] {
  return (
    interactions
      ?.filter((i) => i.interactionType === "reaction")
      .map((i) => ({
        id: i.id,
        emoji: i.content,
        userId: i.user.id,
        userName: i.user.name,
      })) ?? []
  );
}
